import { render, staticRenderFns } from "./PoolRival.vue?vue&type=template&id=8e4a7b26"
import script from "./PoolRival.vue?vue&type=script&lang=js"
export * from "./PoolRival.vue?vue&type=script&lang=js"
import style0 from "./PoolRival.vue?vue&type=style&index=0&id=8e4a7b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports